<template>
  <div class="col-lg-12 pb-5 mb-5">
    <v-tabs icons-and-text mobile-breakpoint="lg" grow>
      <v-tab>
        Borç Bilgileri
        <v-icon> mdi-cash-multiple</v-icon>
      </v-tab>
      <v-tab v-if="borcRiskBilgileri.riskLimit">
        Risk Bilgileri
        <v-icon> mdi-cash-clock</v-icon>
      </v-tab>
      <v-tab>
        Sipariş Bilgileri
        <v-icon> mdi-cash-register</v-icon>
      </v-tab>

      <v-tab-item>
        <v-card>
          <v-card-text>
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td class="font-size-13 font-weight-bold">Borç Toplamı</td>
                  <td class="text-right">{{ numberConverter(borcRiskBilgileri.debit) }}</td>
                </tr>
                <tr>
                  <td class="font-size-13 font-weight-bold">Alacak Toplamı</td>
                  <td class="text-right">{{ numberConverter(borcRiskBilgileri.credit) }}</td>
                </tr>
                <tr>
                  <td class="font-size-13 font-weight-bold">Borç Bakiye</td>
                  <td class="text-right">{{ numberConverter(borcRiskBilgileri.balance) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item v-if="borcRiskBilgileri.riskLimit" >
        <v-card>
          <v-card-text>
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td class="font-size-13 font-weight-bold">Toplam Risk</td>
                  <td :style="{color : borcRiskBilgileri.totalRisk<0 ? 'blue' : 'red'}" class="text-right">{{ numberConverter(borcRiskBilgileri.totalRisk) }}</td>
                </tr>
                <tr>
                  <td class="font-size-13 font-weight-bold">Risk Limiti</td>
                  <td class="text-right">{{ numberConverter(borcRiskBilgileri.riskLimit) }}</td>
                </tr>
                <tr>
                  <td class="font-size-13 font-weight-bold">Vade Günü</td>
                  <td class="text-right">{{ borcRiskBilgileri.termDay }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card>
          <v-card-text>
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td class="font-size-13 font-weight-bold ">Toplam Sipariş Tutarı</td>
                  <td class="text-right">{{ numberConverter(companyInfo.totalB2bSale) }}</td>
                </tr>
                <tr>
                  <td class="font-size-13 font-weight-bold">Toplam Sipariş Adedi</td>
                  <td class="text-right">{{ numberConverter(companyInfo.totalB2bOrder) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";

export default {
  name: "BorcRiskSiparisBilgileri",
  mounted() {
    this._fetchSingleCurrent();
    this._fetchCompanyTotalInfoReport();
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      borcRiskBilgileriLoading : false,
      companyInfoLoading: false,
      borcRiskBilgileri: {
        debit: null,
        credit: null,
        balance: null,
        totalRisk:null,
        riskLimit:null,
        termDay:null,
      },
      companyInfo: {
        totalB2bSale: null,
        totalB2bOrder: null,
      },
    }
  },
  methods: {
    ...mapActions("current", ["fetchSingleCurrent"]),
    ...mapActions("dashboard", ["fetchCompanyTotalInfoReport"]),
    ...mapActions("currencies", ["setDollar", "setEuro", "setPound"]),
    numberConverter,
    async _fetchSingleCurrent(){
      this.borcRiskBilgileriLoading = true;
      await this.fetchSingleCurrent({
        params: {
          currentCode: this.user.userInfo.erpCode,
        },
        urlSegments: [this.user.userInfo.erpCode]
      }).then((result) => {
        if(result){
          this.borcRiskBilgileri.balance = result.balance;
          this.borcRiskBilgileri.debit = result.debit;
          this.borcRiskBilgileri.credit = result.credit;
          this.borcRiskBilgileri.totalRisk = result.totalRisk;
          this.borcRiskBilgileri.riskLimit = result.riskLimit;
          this.borcRiskBilgileri.termDay = result.termDay;
        }
        this.borcRiskBilgileriLoading = false;
      })
    },
    _fetchCompanyTotalInfoReport(){
      this.companyInfoLoading = true;
      this.fetchCompanyTotalInfoReport({
        params: {
          userId: this.user.UserId,
          currentCode: this.user.userInfo.erpCode,
        },
        body: {}
      }).then((result) => {
        if(result){
          this.companyInfo.totalB2bSale = result.data.data.totalB2bSale;
          this.companyInfo.totalB2bOrder = result.data.data.totalB2bOrder;
          this.setDollar(result.data.data.dollar);
          this.setEuro(result.data.data.euro);
          this.setPound(result.data.data.pound);
        }
        this.companyInfoLoading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>
